const presets = [
  '#c9e4ea,#5889ae,#e5e7d2,#92c1d7,#205685',
  '#cc7b86,#4393a6,#ecc4b0,#1c5275,#366a87,#212344',
  '#ddb450,#558962,#0f353d,#eee48e,#eae5c0',
  '#fdd5d2,#fdfbfb,#abbbcf,#ed988b,#ebbdc4',
  '#d9144c,#703b34,#8c3d43,#dcbda5,#96917a',
  '#fed1cc,#f9b7c0,#95c5cc,#e594a7,#dcb4cc,#9a6c78,#dac9bf,#acbac4',
  '#f3e24e,#f0ef79,#f3f6a7,#faf7e7,#c8ca85',
  '#efa22e,#71ac8c,#2a7f73,#fae9ca,#312f45'
]

export default {
  randomset () {
    return presets[Math.floor(Math.random() * presets.length)].split(',')
  }
}



// WEBPACK FOOTER //
// ./src/logic/colorpresets.js